import * as db from '@shared/types/database'
import * as ui from '@/types/frontend'
import { cloneDeep } from 'lodash-es'

export function processAndSortProjects (projects: db.Projects): db.Project[] {
  return sortProjects(processProjects(projects))
}

function processProjects (projects: db.Projects): db.Project[] {
  const newProjects = cloneDeep(projects)
  for (const projectKey in newProjects) {
    // Remove static reports
    if (newProjects[projectKey].type !== 'dynamic') {
      delete newProjects[projectKey]
    } else {
      // Ensure the key is its id
      newProjects[projectKey].id = projectKey
    }
  }
  return Object.keys(newProjects)
    .map(key => ({ ...projects[key], id: key }))
}

function sortProjects (projects: db.Project[]): db.Project[] {
  if (!projects) { return [] }

  return projects.sort((a, b) => {
    const uidA = parseInt(a.id!, 10)
    const uidB = parseInt(b.id!, 10)
    if (uidA > uidB) return -1
    if (uidA < uidB) return 1
    return 0
  })
}

export function validateProject (projectPayload: ui.ProjectPayload): 'A project title is required.' | null {
  // Check for empty title
  if (projectPayload.title.length === 0) {
    return 'A project title is required.'
  } else {
    return null
  }
}
